import SplashTrackingManager from './SplashTrackingManager';

export default new SplashTrackingManager();
